// extracted by mini-css-extract-plugin
export default {"share-button":"shareButton_share-button__RSdVN"};